export default __webpack_public_path__ + "static/media/Dedication.b379c0f9.txt";